// PageTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getOrCreateUserId } from './utils/userTracker';
import axios from './api/axios';
import useAxiosFunction from './hooks/useAxiosFunction';

export default function PageTracker({reportType, observationType, fuelSpillValue, measureControlValue,
  timeDate, siteSelection, contactNumber, supplierSelection, professionSelection, workingArea,
  supplierTextField, witnessed, checked, age, body_part_injured, severity_of_injury, 
  weather, lighting, underfoot_condition, notes, accidentSummary, nameOfCompleting, riddor, file,
  namesOfPplInvolved, memberOfThePublic,  sendSupplierEmail, reportCategory, 
   isSiteTeam,  address1, address2, city,  county,  postcode,  consentToShare,   injuredIndividual,  notOnSite, 
    accidentActionTaken, generateLink,  adminID,   isGoodPractice, 
}) {
  const [response, error, loading, axiosFetch] = useAxiosFunction();
  const location = useLocation();

  useEffect(() => {
    const userSessionId = getOrCreateUserId();
    const navigationData = {
      userSessionId,
      path: location.pathname,
      timestamp: new Date().toISOString(),
      "reportType": reportType,
          "observationType": observationType,
          "fuelSpillage": fuelSpillValue,
          "controlMeasures": measureControlValue,
          "timeDate": timeDate,
          "siteId": siteSelection?.id ?? null,
          "reportCategory":reportCategory ? reportCategory.categoryName : "",
          "contactNumber": contactNumber,
          "supplierId": supplierSelection?.id ?? null,
          "profession": professionSelection ? professionSelection.professionName : "",
          "workingArea": workingArea,
          "manualSupplier": checked,
          "manualSupplierName": supplierTextField,
          "memberOfThePublic" : memberOfThePublic,
          "age": age,
          "bodyPartInjury": body_part_injured,
          "severityOfInjury": severity_of_injury,
          "weatherCondition": weather,
          "lightingCondition": lighting,
          "underfootCondition": underfoot_condition,
          "whoWitnessed": witnessed,
          "notes": notes,
          "accidentSummary": accidentSummary,
          "nameOfCompleting": nameOfCompleting,
          "namesOfPplInvolved": injuredIndividual ? injuredIndividual.first_name+" "+injuredIndividual.last_name : namesOfPplInvolved,
          "address1":address1,
          "address2":address2,
          "city":city,
          "county":county,
          "postcode":postcode,
          "consentToShare":consentToShare,
          "notOnSite":notOnSite,
          "accidentActionTaken":accidentActionTaken,
          "sendSupplierReport":sendSupplierEmail ? sendSupplierEmail : false,
          "riddor": riddor,
          "hasImages":Array.isArray(file) && file.length,
          "isSiteTeam":isSiteTeam,
          "generateLink": generateLink,
          "createdByAdminId":adminID,
          "isGoodPractice":isGoodPractice
    };

    axiosFetch({
      axiosInstance: axios, // or pass a custom instance if needed
      method: 'POST',
      url: '/track-navigation',
      requestConfig: {
        headers: { 'Content-Type': 'application/json' },
        data: navigationData,
      },
    });
  }, [location]);

  return null; // no UI
}
